var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getSelectedImage() != undefined)?_c('div',[(_vm.is_loading)?_c('div',{staticClass:"loading operation_icon"}):_c('img',{staticClass:"operation_icon",staticStyle:{"min-width":"20px","max-width":"20px"},attrs:{"src":_vm.getSelectedImage()},on:{"click":_vm.validateResource,"mouseover":_vm.onMouseOver,"mouseleave":_vm.onMouseLeave}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }